import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Dashboard } from "./dashboard/Dashboard";
import { NewComplaint } from "./newComplaint/NewComplaint";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import "./ComplaintsModuleStyles.css";
import ErrorBoundary from "./common/ErrorBoundary";
import { ComplaintDetails } from "./complaintDetails/ComplaintDetails";
import { userAuthService } from "../auth/UserAuthService";
import { NotAuthorized } from "./errorPages/NotAuthorized";
import { HistoryContext } from "../redux/historyContext";
import { NotFound } from "./errorPages/NotFound";
import { moduleReducerDefinition } from "../redux/configureStore";
import { useSelector } from "react-redux";
import { allCaseRoles } from "../auth/CaseRoles";
import { AnalyticsDashboard } from "./analyticsDashboard/AnalyticsDashboard";
const userSelector = (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.user; };
const hasRole = (usersRoles, rolesToCheck) => usersRoles.some((usersRole) => rolesToCheck.includes(usersRole.toString()));
const _ComplaintsModule = ({ match, history }) => {
    const { path } = match;
    // temporary code: auth info is no longer to be found in props passed to the module, as
    //  it is now in the redux store. For the moment keep the complaints module code as is
    //  and feed this stuff back in to userAuthService here.  Long term, the sagas should
    //  pick out the auth info from the atore themselves, so this code would disappear.
    const user = useSelector(userSelector);
    if (!user) {
        return React.createElement(React.Fragment, null, "Missing Authorization information");
    }
    const { upn, displayName, roles, token, experimentalFeatures } = user;
    userAuthService.initialise({
        upn,
        displayName,
        roles,
        apiToken: token,
        accessToken: token,
        experimentalFeatures,
    });
    return (React.createElement(HistoryContext.Provider, { value: history },
        React.createElement(ErrorBoundary, null,
            React.createElement("div", { className: "ComplaintsModule" },
                React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
                    React.createElement(Switch, null,
                        React.createElement(Route, { path: `${path}/not-authorized` },
                            React.createElement(NotAuthorized, null)),
                        React.createElement(Route, { path: `${path}/not-found` },
                            React.createElement(NotFound, null)),
                        React.createElement(Route, { path: `${path}/new` },
                            React.createElement(NewComplaint, { returnRoute: path })),
                        React.createElement(Route, { path: `${path}/list` },
                            React.createElement(Dashboard, null)),
                        React.createElement(Route, { path: `${path}/:id/:tabId?` },
                            React.createElement(ComplaintDetails, null)),
                        React.createElement(Route, { path: `${path}` },
                            React.createElement(AnalyticsDashboard, null))))))));
};
const ComplaintsModule = _ComplaintsModule;
class AppContainer extends React.Component {
    render() {
        return React.createElement(ComplaintsModule, Object.assign({}, this.props));
    }
}
const routedComplaintsModule = withRouter(AppContainer);
export default routedComplaintsModule;
export const moduleDefinition = {
    component: routedComplaintsModule,
    redux: moduleReducerDefinition,
    visibleOnNavigationBar: (user) => {
        return hasRole(user.roles, allCaseRoles);
    },
};
